module.exports = __webpack_public_path__ + "static/media/event_img-2-1.441c5bb9.png";